// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import classnames from "classnames";
import { Link } from "react-router-dom";

const styles = (theme) => ({
    item: {
        paddingLeft: 45,
    },
    topicItemNumber: {
        color: "#e40045",
        marginRight: 12,
    },
    icon: {
        marginLeft: "auto",
        color: "#303c49",
        transform: "rotate(90deg)",
    },
    selected: {
        backgroundColor: "#d6d8db",
    },
});

const EMobilityTocTopic = ({ classes, title, number, selected, to, href }) => {
    if (href) {
        return (
            <ListItem
                button
                component="a"
                href={href}
                className={classnames(classes.item, { [classes.selected]: selected })}
            >
                <span className={classes.topicItemNumber}>{number}</span>
                <span>{title}</span>
            </ListItem>
        );
    }

    return (
        <ListItem
            button
            component={Link}
            to={to}
            className={classnames(classes.item, { [classes.selected]: selected })}
        >
            <span className={classes.topicItemNumber}>{number}</span>
            <span>{title}</span>
        </ListItem>
    );
};

export default compose(withStyles(styles))(EMobilityTocTopic);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityTocChapter.js